module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "go-to-box-area"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t(_vm.title)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success btn-block",
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.buttonText)))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger btn-block",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.closeMe
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bef26c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoTo.vue
// module id = 305
// module chunks = 1